import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {RootState} from "@/store/store";

interface SearchState {
    isSearching: boolean;
}

const initialState: SearchState = {
    isSearching: false,
};

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setIsSearching: (state, action: PayloadAction<boolean>) => {
            state.isSearching = action.payload;
        },
    },
});

export const { setIsSearching } = searchSlice.actions;

export const selectIsSearching = (state: RootState) => state.search.isSearching;

export default searchSlice.reducer;
